const tr = {
    common: {
        loading: 'Yükleniyor',
        processing: 'İşleniyor',
        save: 'Kaydet',
        cancel: 'Vazgeç',
        close: 'Kapat',
        back: 'Geri',
        ok: 'Tamam',
        online: 'Çevrimiçi',
        offline: 'Çevrimdışı',
        sendMessage: 'Mesaj gönder'
    },
    presence: {
        label: 'Durum',
        online: 'Çevrimiçi',
        idle: 'Boşta',
        dnd: 'Rahatsız etmeyin',
        invisible: 'Görünmez',
        offline: 'Çevrimdışı',
        hint: {
            online: 'Arkadaşların seni çevrimiçi görür.',
            idle: 'Boşta görünürsün. Bir süre işlem yapmazsan da kendiliğinden boşta görünürsün.',
            dnd: 'Bildirim balonları ve sesler kapanır; bildirimler listede yine birikir.',
            invisible: 'Herkes seni çevrimdışı görür ama uygulamayı normal kullanırsın.'
        }
    },
    profile: {
        favorite: 'Favorilere ekle',
        unfavorite: 'Favorilerden çıkar',
        viewFull: 'Tam profili görüntüle',
        editProfile: 'Profili düzenle',
        addFriend: 'Arkadaş ekle',
        cancelRequest: 'İsteği geri çek',
        accept: 'Kabul et',
        decline: 'Reddet',
        removeFriend: 'Arkadaşlıktan çıkar',
        removeConfirm: '{{name}} arkadaşlarından çıkarılsın mı?',
        block: 'Engelle',
        blockConfirm: '{{name}} engellensin mi? Arkadaşlığınız biter ve birbirinize mesaj atamazsınız.',
        unblock: 'Engeli kaldır',
        memberSince: '{{date}} tarihinden beri üye',
        mutualFriendCount: '{{count}} ortak arkadaş',
        mutualGroupCount: '{{count}} ortak grup',
        tabAbout: 'Hakkında',
        tabFriends: 'Ortak arkadaşlar',
        tabGroups: 'Ortak gruplar',
        noMutualFriends: 'Ortak arkadaşınız yok.',
        noMutualGroups: 'Ortak grubunuz yok.',
        notFound: 'Bu kullanıcı bulunamadı.',
        loadFailed: 'Profil yüklenemedi.',
        actionFailed: 'İşlem yapılamadı, tekrar dene.'
    },
    profileEdit: {
        title: 'Profil görünümü',
        hint: 'Profil kartında herkesin göreceği banner, renkler, hakkında yazısı ve bağlantılar.',
        banner: 'Banner',
        uploadBanner: 'Banner yükle',
        removeBanner: 'Banner\'ı kaldır',
        bannerColor: 'Banner rengi',
        cropBanner: 'Banner\'ı kırp',
        colors: 'Profil renkleri',
        colorPrimary: 'Ana renk',
        colorAccent: 'Vurgu rengi',
        colorsHint: 'Profil kartın bu iki renkle boyanır.',
        about: 'Hakkımda',
        aboutPlaceholder: 'Kendinden biraz bahset…',
        aboutFormatting: '**kalın**, *italik*, `kod` ve linkler kullanılabilir',
        links: 'Bağlantılar',
        addLink: 'Bağlantı ekle',
        removeLink: 'Bağlantıyı kaldır',
        platform: 'Platform',
        url: 'Adres',
        reset: 'Sıfırla',
        save: 'Profili kaydet',
        saved: 'Profil kaydedildi.',
        preview: 'Önizleme',
        platforms: {
            website: 'Web sitesi', github: 'GitHub', steam: 'Steam', spotify: 'Spotify',
            instagram: 'Instagram', youtube: 'YouTube', x: 'X (Twitter)', twitch: 'Twitch'
        },
        errors: {
            TOO_LONG: 'Bir alan çok uzun.',
            INVALID_COLOR: 'Geçersiz renk.',
            TOO_MANY: 'En fazla 5 bağlantı ekleyebilirsin.',
            INVALID_URL: 'Bağlantı https:// ile başlayan geçerli bir adres olmalı.',
            WRONG_SITE: 'Bağlantı seçilen platformun sitesine ait değil.',
            INVALID_PLATFORM: 'Geçersiz platform.',
            INVALID: 'Geçersiz değer.'
        }
    },
    media: {
        cropTitle: 'Fotoğrafı kırp',
        cropGroupIconTitle: 'Grup simgesini kırp',
        zoom: 'Yakınlaştır',
        zoomIn: 'Yakınlaştır',
        zoomOut: 'Uzaklaştır',
        apply: 'Kaydet',
        errors: {
            generic: 'Görsel yüklenemedi.',
            NO_FILE: 'Bir görsel seç.',
            UNSUPPORTED_TYPE: 'Bu dosya desteklenmiyor. PNG, JPEG, GIF ya da WebP seç.',
            FILE_TOO_LARGE: 'Dosya çok büyük, en fazla 10 MB olabilir.',
            TOO_LARGE_DIMENSIONS: 'Görselin çözünürlüğü çok yüksek.',
            TOO_MANY_FRAMES: 'GIF çok fazla kare içeriyor (en fazla 300).',
            TOO_LONG: 'GIF çok uzun (en fazla 15 saniye).',
            OUTPUT_TOO_LARGE: 'Bu GIF küçültüldükten sonra bile çok büyük. Daha kısa ya da daha küçük bir GIF dene.',
            INVALID_CROP: 'Kırpma alanı geçersiz.',
            BAD_UPLOAD: 'Yükleme bozuk geldi, tekrar dene.',
            RATE_LIMITED: 'Çok sık görsel yükledin, biraz sonra tekrar dene.',
            NETWORK: 'Bağlantı hatası, tekrar dene.',
            BAD_RESPONSE: 'Sunucudan beklenmeyen bir yanıt geldi.'
        }
    },
    navShort: {
        chats: 'Sohbet',
        friends: 'Arkadaşlar',
        groups: 'Gruplar',
        notifications: 'Bildirim',
        settings: 'Ayarlar'
    },
    nav: {
        chats: 'Sohbetler',
        friends: 'Arkadaşlar',
        groups: 'Gruplar',
        notifications: 'Bildirimler',
        settings: 'Ayarlar',
        logout: 'Çıkış yap',
        admin: 'Yönetim paneli'
    },
    auth: {
        authenticating: 'Kimlik doğrulanıyor...',
        usernamePlaceholder: 'Kullanıcı adı',
        passwordPlaceholder: 'Şifre',
        confirmPasswordPlaceholder: 'Şifre Tekrar',
        emailPlaceholder: 'E-posta',
        signIn: 'Giriş yap',
        signUp: 'Kayıt ol',
        back: 'Geri',
        processing: 'İşleniyor',
        registrationSuccess: 'Kaydın başarıyla oluşturuldu. Giriş yapılıyor...',
        forgotPassword: 'Şifremi unuttum',
        forgotPasswordHint: 'Hesabına kayıtlı e-posta adresini gir, şifreni sıfırlaman için sana bir bağlantı gönderelim.',
        sendResetLink: 'Sıfırlama bağlantısı gönder',
        forgotPasswordSuccess: 'Şifreni sıfırlaman için bir bağlantı gönderdik. Gelen kutunu (ve spam klasörünü) kontrol et.'
    },
    chat: {
        title: 'Sohbetler',
        subtitle: 'Arkadaşlarınla iletişimde kal!',
        emptyFriends: 'Sohbet etmeye başlamak için arkadaş ekle!',
        sayHi: 'Merhaba de!',
        selectFriend: 'Sohbet etmeye başlamak için bir arkadaş seç.',
        inputPlaceholder: 'Mesaj gönder!',
        today: 'Bugün',
        yesterday: 'Dün',
        sendFailed: 'Mesaj gönderilemedi.'
    },
    friends: {
        title: 'Arkadaşlar',
        empty: 'Henüz hiç arkadaşın yok. Birini aramayı dene!',
        accept: 'Kabul et',
        ignore: 'Yoksay',
        unblock: 'Engeli Kaldır',
        requestSent: '@{{name}} kullanıcısına istek gönderildi.',
        nowFriends: '@{{name}} ile artık arkadaşsınız.',
        emptyOnline: 'Şu an çevrimiçi arkadaşın yok.',
        emptyPending: 'Bekleyen arkadaşlık isteği yok.',
        emptyBlocked: 'Kimseyi engellemedin.',
        incoming: 'Gelen istekler ({{count}})',
        outgoing: 'Gönderilen istekler ({{count}})',
        tabs: { online: 'Çevrimiçi', all: 'Tümü', pending: 'Bekleyen', blocked: 'Engellenen' }
    },
    people: {
        subtitle: 'Arkadaşlarını gör, yeni insanlar bul.',
        searchPlaceholder: 'Ara veya kullanıcı adıyla ekle',
        clearSearch: 'Aramayı temizle',
        friendsSection: 'Arkadaşlar ({{count}})',
        othersSection: 'Diğer kullanıcılar',
        typeMore: 'Diğer kullanıcıları aramak için en az 3 harf yaz.',
        searching: 'Aranıyor…',
        searchFailed: 'Arama yapılamadı, tekrar dene.',
        noResults: 'Bu aramaya uyan kimse yok.',
        more: 'Daha fazla',
        incomingTitle: 'Seni bekleyen istekler ({{count}})',
        suggestionsTitle: 'Tanıyor olabileceğin kişiler',
        mutualFriendsOne: '{{count}} ortak arkadaş',
        mutualFriends: '{{count}} ortak arkadaş',
        mutualGroupsOne: '{{count}} ortak grup',
        mutualGroups: '{{count}} ortak grup',
        requestSent: 'İstek gönderildi',
        hide: 'Gizle',
        welcomeTitle: 'Arkadaşlarını bul',
        welcomeBody: 'Henüz kimse yok. Tanıdıklarını kullanıcı adı ya da isimle arayıp ekleyebilirsin.',
        findPeople: 'Kişi ara',
        activeTitle: 'Şu an aktif ({{count}})',
        inVoice: 'Seste',
        personalRoom: '{{name}} odası',
        openGroup: 'Gruba git',
        favoritesSection: 'Favoriler ({{count}})',
        restSection: 'Diğer arkadaşlar ({{count}})'
    },
    settings: {
        changePhoto: 'Fotoğrafı değiştir',
        removePhoto: 'Kaldır',
        noStatus: 'Henüz bir durum yazmadın.',
        sectionProfile: 'Profil bilgileri',
        sectionProfileHint: 'Adın, kullanıcı adın ve durumun herkese görünür.',
        sectionAccount: 'Hesap',
        sectionAccountHint: 'E-posta adresin yalnızca sana görünür.',
        sectionSecurity: 'Güvenlik',
        sectionSecurityHint: 'Şifreni değiştirmek için mevcut şifreni isteyeceğiz.',
        sectionAppearance: 'Görünüm',
        sectionAppearanceHint: 'Dil ve tema tercihlerin bu cihazda saklanır.',
        sectionVoice: 'Ses ve görüşme',
        sectionVoiceHint: 'Sesli odalara nasıl bağlanacağını buradan ayarla.',
        sectionSession: 'Oturum',
        logoutConfirm: 'Çıkış yapmak istediğine emin misin?',
        micDefaultOn: 'Mikrofon açık bağlan',
        micDefaultOnHint: 'Açıksa, bir sesli odaya her girişinde mikrofonun otomatik olarak açık olur. Kapalıysa (varsayılan), odaya sessiz girer ve mikrofonu istediğin an kendin açarsın.',
        title: 'Ayarlar',
        subtitle: 'Profil ayarlarını düzenle',
        fullname: 'Ad Soyad',
        username: 'Kullanıcı Adı',
        status: 'Durum',
        email: 'E-posta Adresi',
        password: 'Şifre',
        passwordConfirm: 'Şifre Tekrar',
        currentPassword: 'Mevcut Şifre',
        discardChanges: 'Değişiklikleri Geri Al',
        saveChanges: 'Değişiklikleri Kaydet',
        loading: 'Yükleniyor...',
        language: 'Dil',
        theme: 'Tema',
        themeHint: 'Sade temalarda arka plan animasyonu kapalıdır.',
        themeNames: {
            'cyclone': 'Cyclone (Varsayılan)',
            'plain-blue': 'Sade Mavi',
            'dracula': 'Dracula',
            'nord': 'Nord',
            'tokyo-night': 'Tokyo Night',
            'catppuccin': 'Catppuccin Mocha',
            'gruvbox': 'Gruvbox Dark',
            'one-dark': 'One Dark',
            'solarized-light': 'Solarized Light',
            'sakura': 'Pembe Sakura',
            'lotr': 'Yüzüklerin Efendisi',
            'win98': 'Windows 98',
            'macos': 'macOS',
            'valorant': 'Valorant'
        }
    },
    notifications: {
        title: 'Bildirimler',
        subtitle: 'Arkadaşlık istekleri, mesajlar ve diğer etkinlikler',
        empty: 'Her şey güncel. Henüz burada bir şey yok.',
        justNow: 'az önce',
        minutesAgo: '{{count}} dk önce',
        hoursAgo: '{{count}} sa önce',
        daysAgo: '{{count}} gün önce'
    },
    meeting: {
        // Standalone meeting pages (screens/Meeting.js) - the one surface a
        // non-Cyclone guest ever sees, reached from a shared link.
        startMeeting: 'Toplantı başlat',
        startMeetingDesc: 'Bağlantıyı paylaş, hesabı olmayanlar da katılsın',
        creating: 'Oluşturuluyor...',
        activeMeeting: 'Açık toplantın var',
        joinYours: 'Katıl',
        linkCopied: 'Toplantı bağlantısı kopyalandı',
        createFailed: 'Toplantı oluşturulamadı.',
        loading: 'Toplantı yükleniyor...',
        info: 'Toplantı bilgileri',
        shareLink: 'Bu bağlantıyı paylaş',
        copyLink: 'Bağlantıyı kopyala',
        copyInvite: 'Davet bağlantısını kopyala',
        copied: 'Kopyalandı',
        participants: 'Katılımcılar',
        chat: 'Sohbet',
        chatEmpty: 'Henüz mesaj yok. Buradaki mesajlar toplantı bitince kaybolur.',
        chatPlaceholder: 'Herkese mesaj gönder',
        close: 'Kapat',
        more: 'Diğer seçenekler',
        backToGrid: 'Izgara görünümüne dön',
        endConfirm: '"{{title}}" toplantısı herkes için bitirilsin mi?',
        endForAll: 'Toplantıyı herkes için bitir',
        leave: 'Toplantıdan ayrıl',
        micOn: 'Mikrofonu aç',
        micOff: 'Mikrofonu kapat',
        cameraOn: 'Kamerayı aç',
        cameraOff: 'Kamerayı kapat',
        share: 'Ekranı paylaş',
        stopShare: 'Paylaşımı durdur',
        reactions: 'Tepkiler',
        raiseHand: 'El kaldır',
        lowerHand: 'Eli indir',
        handRaised: 'El kaldırdı',
        muted: 'Mikrofonu kapalı',
        pin: 'Sabitle',
        unpin: 'Sabitlemeyi kaldır',
        pinned: 'Sabitlendi',
        fullscreen: 'Tam ekran',
        removeParticipant: 'Toplantıdan çıkar',
        removedNotice: '{{name}} toplantıdan çıkarıldı.',
        audioDevices: 'Mikrofon seç',
        videoDevices: 'Kamera seç',
        microphone: 'Mikrofon',
        camera: 'Kamera',
        screenOf: '{{name}} - ekran',
        youSuffix: '(sen)',
        waitingForOthers: 'Diğerleri bekleniyor...',
        goToCyclone: "Cyclone'a git",
        rejoin: 'Yeniden katıl',
        leftTitle: 'Toplantıdan ayrıldın',
        leftBody: 'Fikrini değiştirirsen aynı bağlantıdan geri dönebilirsin.',
        endedTitle: 'Toplantı sona erdi',
        endedBody: 'Bu bağlantı artık kullanılamıyor.',
        cyclonePitch: 'Cyclone; gruplar, sesli odalar ve sohbet için kullanılan bir uygulama. Bir göz at.',
        quality: {
            title: 'Gönderilen görüntü',
            high: 'Yüksek',
            balanced: 'Dengeli',
            low: 'Düşük',
            hint: 'Yalnızca senin gönderdiğin görüntüyü etkiler. Karşı tarafta ne görüleceği kutucuk boyutuna göre zaten kendiliğinden ayarlanıyor.'
        },
        background: {
            title: 'Arka plan',
            none: 'Kapalı',
            blur: 'Bulanık',
            scenes: { mordor: 'Mordor', space: 'Uzay' },
            together: 'Herkesi bu sahneye al',
            togetherStop: 'Birlikte modunu kapat',
            togetherOn: 'Herkes aynı sahnede. Kutucuklar tek bir mekân gibi birleşti.',
            togetherHint: 'Önce bir sahne seç, sonra herkesi aynı sahneye alabilirsin.'
        },
        annotate: {
            draw: 'Ekrana çiz',
            stop: 'Çizmeyi bırak',
            clearMine: 'Kendi çizimlerimi sil',
            clearAll: 'Tüm çizimleri sil'
        },
        transcript: {
            tab: 'Transkript',
            start: 'Transkripti başlat',
            stop: 'Transkripti durdur',
            live: 'Transkript açık',
            starting: 'Transkript başlıyor...',
            off: 'Transkript kapalı',
            error: 'Transkript hatası',
            listening: 'Dinleniyor, konuşulduğunda burada görünecek.',
            empty: 'Bu toplantıda henüz transkript alınmadı.',
            failed: 'Transkript değiştirilemedi.',
            summaryTitle: 'Toplantı özeti',
            summaryPending: 'Özet hazırlanıyor...',
            summarySkipped: 'Özetlenecek kadar konuşma olmadı.',
            summaryFailed: 'Özet oluşturulamadı, transkript duruyor.'
        },
        lobby: {
            hostedBy: '{{name}} tarafından oluşturuldu',
            whoIsInside: 'Toplantıdakiler',
            nobodyYet: 'Henüz kimse katılmadı, ilk sen olacaksın.',
            inside: '{{names}} toplantıda',
            insideWithMore: '{{names}} ve {{count}} kişi daha toplantıda',
            yourName: 'Adın',
            namePlaceholder: 'Toplantıda görünecek ad',
            joiningAs: '{{name}} olarak katılıyorsun',
            join: 'Hemen katıl',
            joining: 'Katılınıyor...',
            hint: 'Mikrofonunu ve kameranı toplantı sırasında istediğin zaman açıp kapatabilirsin.',
            cameraOff: 'Kamera kapalı',
            cameraBlocked: 'Kameraya erişilemedi. Tarayıcı iznini kontrol et.',
            code: 'Toplantı kodu: {{code}}'
        },
        errors: {
            notFoundTitle: 'Toplantı bulunamadı',
            notFound: 'Bu koda ait bir toplantı yok ya da süresi dolmuş.',
            joinFailed: 'Toplantıya katılınamadı.',
            endFailed: 'Toplantı bitirilemedi.',
            removeFailed: 'Katılımcı çıkarılamadı.',
            disconnected: 'Toplantı bağlantın koptu. Yeniden katılabilirsin.',
            screenPermission: 'Ekran paylaşımı izni verilmemiş. Sistem ayarlarından izin ver.'
        }
    },
    groups: {
        changeIcon: 'Grup ikonunu değiştir',
        removeIcon: 'Grup ikonunu kaldır',
        title: 'Gruplar',
        subtitle: 'Aynı anda birden fazla arkadaşınla takıl',
        newGroup: 'Yeni grup',
        createGroupTitle: 'Grup oluştur',
        noGroupsYet: 'Henüz hiçbir grupta değilsin.',
        memberCount: '{{count}}/20 üye',
        youOwnThis: ' - bu senin grubun',
        inviteFriend: 'Arkadaş davet et',
        leaveGroup: 'Gruptan ayrıl',
        leaveGroupConfirm: '{{name}} grubundan ayrılmak istediğine emin misin?',
        deleteGroup: 'Grubu sil',
        deleteGroupConfirm: '{{name}} grubu tüm üyeleri ve odalarıyla birlikte kalıcı olarak silinsin mi? Bu geri alınamaz.',
        groupDeleted: 'Grup silindi.',
        selectGroup: 'Bir grup seç ya da yeni bir tane oluştur.',
        createModalTitle: 'Grup oluştur',
        groupNamePlaceholder: 'Grup adı',
        create: 'Oluştur',
        inviteModalTitle: 'Arkadaş davet et',
        invite: 'Davet et',
        inviteSent: 'Davet gönderildi',
        allFriendsInGroup: 'Tüm arkadaşların zaten bu grupta.',
        addFriendsFirst: 'Davet edebilmek için önce arkadaş eklemelisin.',
        incomingInvitesTitle: 'Grup davetleri',
        invitedToGroup: '{{inviter}} seni "{{group}}" grubuna davet etti',
        acceptInvite: 'Kabul et',
        declineInvite: 'Reddet',
        yourSuffix: ' (senin)',
        youSuffix: ' (sen)',
        groupOwner: 'Grup sahibi',
        kick: 'At',
        kickConfirm: '{{name}} odadan atılsın mı?',
        manageMembers: 'Üyeleri yönet',
        membersModalTitle: 'Üyeler',
        removeMember: 'Gruptan çıkar',
        removeMemberConfirm: '{{name}} gruptan çıkarılsın mı?',
        noOtherMembers: 'Şimdilik burada tek başınasın.',
        roomEmpty: 'Boş',
        enter: 'Gir',
        knock: 'Kapıyı çal',
        doorState: {
            knock: 'Kapıyı Çal',
            open: 'Açık',
            dnd: 'Rahatsız Etmeyin',
            locked: 'Kilitli'
        },
        availability: {
            offline: 'Çevrimdışı',
            ownerless: 'Boş (sahibi çevrimdışı)',
            available: 'Müsait',
            in_own_room: 'Kendi odasında',
            elsewhere: 'Başka yerde'
        }
    },
    knock: {
        knockingOnDoor: '{{name}} kapını çalıyor',
        expiresIn: '{{seconds}} sn içinde sona erecek',
        letThemIn: 'İçeri al',
        ignore: 'Yoksay',
        knocking: 'Kapı çalınıyor...',
        waitingForAnswer: 'Yanıt bekleniyor - {{seconds}} sn kaldı',
        cancel: 'Vazgeç',
        resultAccepted: 'Seni içeri aldılar!',
        resultRejected: 'Seni geri çevirdiler.',
        resultExpired: 'Kimse zamanında yanıt vermedi.',
        resultCancelled: 'Kapı çalma iptal edildi.',
        resultDefault: 'Kapı çalma sonuçlandı.'
    },
    reactions: {
        title: 'Tepkiler',
        throw: 'Fırlat',
        tea: 'Herkese çay!',
        coffee: 'Herkese kahve!'
    },
    voiceSheet: {
        expand: 'Oda panelini aç',
        collapse: 'Küçült',
        tabPeople: 'Kişiler',
        tabMusic: 'Müzik',
        tabLyrics: 'Sözler',
        tabTranscript: 'Transkript',
        mic: 'Mikrofon',
        camera: 'Kamera',
        screen: 'Ekran',
        video: 'Görüntü',
        transcript: 'Transkript',
        leave: 'Ayrıl',
        speaking: '{{names}} konuşuyor',
        noLyrics: 'Söz göstermek için önce bir şarkı çal.',
        volume: 'Ses seviyesi'
    },
    voice: {
        inRoom: 'Odadakiler',
        you: 'sen',
        participantCount: '{{count}} kişi',
        connected: 'Bağlandı',
        connecting: 'Bağlanıyor...',
        mute: 'Sustur',
        unmute: 'Sesi Aç',
        leaveRoom: 'Odadan ayrıl',
        defaultRoomLabel: 'Sesli oda',
        personalRoomLabel: '{{name}} Odası',
        microphone: 'Mikrofon',
        camera: 'Kamera',
        cameraOn: 'Kamerayı aç',
        cameraOff: 'Kamerayı kapat',
        showVideo: 'Görüntülü görüşmeyi göster',
        hideVideo: 'Görüntülü görüşmeyi gizle',
        startScreenShare: 'Ekranını paylaş',
        stopScreenShare: 'Ekran paylaşımını durdur',
        screenSharingTitle: '{{name}} ekranını paylaşıyor',
        screenPermissionDenied: 'Cyclone\'un ekranını paylaşabilmesi için Ekran Kaydı izni gerekiyor.',
        openSettings: 'Ayarları Aç',
        screenPickerTitle: 'Ne paylaşmak istersin?',
        screenPickerScreens: 'Ekranlar',
        screenPickerWindows: 'Pencereler',
        screenPickerLoading: 'Yükleniyor...',
        screenPickerEmpty: 'Burada paylaşılacak bir şey yok.',
        screenPickerMacAudioNote: 'Sistem sesi yalnızca macOS 15+ üzerinde sistem seçicisiyle paylaşılabilir.'
    },
    music: {
        requestedBy: 'Açan:',
        searchTitle: 'Ara ve sıraya ekle',
        queue: 'Sırada',
        queueCount: 'Sırada ({{count}})',
        addToQueue: 'Sıraya ekle',
        addedToQueue: 'Sıraya eklendi.',
        enqueueFailed: 'Sıraya eklenemedi.',
        queueFull: 'Sıra dolu, önce birkaç şarkı çıkar.',
        skip: 'Sonraki şarkı',
        removeFromQueue: 'Sıradan kaldır',
        clearQueue: 'Sırayı temizle',
        clearQueueConfirm: 'Sıradaki {{count}} şarkının hepsi kaldırılsın mı?',
        shuffleQueue: 'Karıştır',
        moveUp: 'Yukarı taşı',
        moveDown: 'Aşağı taşı',
        searchPlaceholder: 'YouTube\'da ara...',
        searchButton: 'Ara',
        searching: 'Aranıyor...',
        noResults: 'Sonuç bulunamadı.',
        nowPlaying: 'Şu an çalıyor',
        play: 'Çal',
        pause: 'Duraklat',
        resume: 'Devam et',
        loop: 'Loop',
        loopOn: 'Loop (açık)',
        stop: 'Durdur',
        error: 'Çalma başarısız oldu - video artık mevcut olmayabilir.',
        watchTogether: 'Birlikte izle',
        watchTogetherFailed: 'İzleme başlatılamadı.',
        pasteUrlPlaceholder: 'veya bir video linki yapıştır',
        stopWatchTogether: 'İzlemeyi herkes için durdur',
        stopWatchTogetherConfirm: 'İzleme odadaki herkes için sona erecek. Emin misin?',
        minimizeWatchTogether: 'Küçült (izleme devam eder)',
        tapToJoin: 'İzlemeye katılmak için dokun',
        showWatchTogether: 'İzlemeyi göster',
        fullscreen: 'Tam ekran',
        exitFullscreen: 'Tam ekrandan çık',
        invalidVideoUrl: 'Bu link oynatılabilir bir video gibi görünmüyor.',
        youtubeVideoNotFound: 'Bu YouTube videosu bulunamadı.',
        checkingVideoUrl: 'Kontrol ediliyor...',
        syncingWithEveryone: 'Herkesle eşitleniyor...',
        waitingForParticipant: '{{name}} bekleniyor...',
        pausedForParticipant: '{{name}} kişisinin bağlantısı sebebiyle duraklatıldı'
    },
    transcript: {
        start: 'Transkripsiyonu başlat',
        startConfirm: 'Odadaki herkesin konuşmaları yazıya dökülüp kaydedilecek. Başlatılsın mı?',
        stop: 'Transkripsiyonu durdur',
        recordingBadge: 'Konuşmalar yazıya dökülüyor · {{name}} başlattı',
        panelTitle: 'Transkript',
        empty: 'Henüz kayıtlı bir konuşma yok.',
        summaryReady: 'Konuşma özeti hazır.',
        historyTitle: 'Geçmiş konuşmalar',
        historyLoading: 'Yükleniyor...',
        historyEmpty: 'Bu oda için henüz kayıtlı bir oturum yok.',
        historySelectPrompt: 'Detayları görmek için soldan bir oturum seç.',
        historyLoadFailed: 'Oturum yüklenemedi.',
        summaryPending: 'Özet hazırlanıyor...',
        summaryFailed: 'Özet oluşturulamadı.',
        summarySkipped: 'Bu oturum için özet oluşturulmadı.',
        summaryRegenerate: 'Özeti yeniden oluştur',
        summaryRegenerating: 'Oluşturuluyor...',
        summaryRegenerateSuccess: 'Özet güncellendi.',
        summaryRegenerateFailed: 'Özet oluşturulamadı, tekrar dene.'
    },
    lyrics: {
        panelTitle: 'Sözler',
        loading: 'Sözler aranıyor...',
        notFound: 'Bu şarkı için söz bulunamadı.',
        failed: 'Sözler yüklenemedi.',
        expand: 'Tam ekran',
        syncAdjust: 'Senkron ayarı'
    },
    toasts: {
        friendRequestReceived: '{{name}} sana arkadaşlık isteği gönderdi',
        friendRequestAccepted: '{{name}} arkadaşlık isteğini kabul etti',
        removedFromRoom: 'Odadan çıkarıldın.',
        kickedOtherDevice: 'Başka bir cihazdan bir odaya katıldığın için bu bağlantı kesildi.',
        joinedGroup: '{{name}} gruba katıldı',
        groupInviteReceived: '{{name}} seni {{group}} grubuna davet etti',
        removedFromGroup: 'Grup sahibi seni gruptan çıkardı.',
        groupDeleted: '{{name}} grubu sahibi tarafından silindi.'
    },
    admin: {
        nav: {
            dashboard: 'Genel bakış',
            users: 'Kullanıcılar',
            settings: 'Ayarlar',
            auditLog: 'İşlem kaydı',
            backToApp: 'Uygulamaya dön'
        },
        dashboard: {
            title: 'Genel bakış',
            subtitle: 'Platform özeti',
            totalUsers: 'Toplam kullanıcı',
            newToday: 'Bugün katılan',
            newThisWeek: 'Bu hafta katılan',
            newThisMonth: 'Bu ay katılan',
            online: 'Şu an çevrimiçi',
            onlineUsersTitle: 'Şu an çevrimiçi olanlar',
            noOnlineUsers: 'Şu an kimse çevrimiçi değil.'
        },
        users: {
            title: 'Kullanıcılar',
            subtitle: 'Kullanıcı adı/e-posta ile ara, banla, oturumları kapat, admin rolü yönet',
            searchPlaceholder: 'Kullanıcı adı, e-posta veya isimle ara...',
            filterRoleAll: 'Tüm roller',
            filterRoleAdmin: 'Admin',
            filterRoleUser: 'Kullanıcı',
            filterBannedAll: 'Tüm durumlar',
            filterBannedYes: 'Banlı',
            filterBannedNo: 'Banlı değil',
            columnUser: 'Kullanıcı',
            columnRole: 'Rol',
            columnStatus: 'Durum',
            columnCreated: 'Kayıt tarihi',
            columnLastActive: 'Son aktiflik',
            columnActions: 'Aksiyonlar',
            never: 'Hiç',
            banned: 'Banlı',
            ban: 'Banla',
            unban: 'Ban kaldır',
            forceLogout: 'Oturumları kapat',
            grantAdmin: 'Admin yap',
            revokeAdmin: 'Adminliği al',
            banReasonLabel: 'Sebep (opsiyonel)',
            banReasonPlaceholder: 'Bu hesap neden banlanıyor?',
            confirmBan: '{{username}} banlansın mı? Her yerden çıkış yapılacak ve tekrar giriş yapamayacak.',
            confirmUnban: '{{username}} kullanıcısının banı kaldırılsın mı? Tekrar giriş yapabilecek.',
            confirmForceLogout: '{{username}} tüm cihazlardan çıkış yaptırılsın mı?',
            confirmGrantAdmin: '{{username}} kullanıcısına admin yetkisi verilsin mi?',
            confirmRevokeAdmin: '{{username}} kullanıcısının admin yetkisi alınsın mı?',
            resetProfile: 'Profili temizle',
            confirmResetProfile: "{{username}} kullanıcısının profilinden seçilenler kaldırılsın mı?",
            resetParts: { avatar: 'Profil fotoğrafı', banner: 'Banner ve profil renkleri', text: 'Durum satırı, hakkımda ve bağlantılar' },
            empty: 'Bu aramaya uyan kullanıcı yok.',
            prev: 'Önceki',
            next: 'Sonraki',
            pageInfo: 'Sayfa {{page}} / {{total}}'
        },
        settings: {
            title: 'Ayarlar',
            subtitle: 'Platform geneli kontroller',
            registrationOpenLabel: 'Yeni kayıtlar',
            registrationOpenHint: 'Kapalıyken yeni hesap açılamaz.',
            closedMessageLabel: 'Kayıt kapalıyken gösterilecek mesaj',
            closedMessagePlaceholder: 'ör. "Kayıtlar geçici olarak kapalı, yakında tekrar deneyin."',
            save: 'Kaydet',
            saved: 'Kaydedildi.',
            announcementTitle: 'Platform duyurusu',
            announcementHint: 'Şu an çevrimiçi olan herkese anında gönderilir. Sonradan bağlanacaklar için hiçbir yerde saklanmaz.',
            announcementPlaceholder: 'ör. "Ses sunucuları 10 dakika içinde yeniden başlatılacak, kısa süreliğine bağlantınız kesilebilir."',
            announcementSend: 'Çevrimiçi herkese gönder',
            announcementConfirm: 'Bu duyuru şu an bağlı olan tüm kullanıcılara gönderilsin mi?',
            announcementSent: 'Gönderildi.'
        },
        auditLog: {
            title: 'İşlem kaydı',
            subtitle: 'Her admin aksiyonu, kim yaptı ve ne zaman',
            columnTime: 'Zaman',
            columnActor: 'Admin',
            columnAction: 'Aksiyon',
            columnTarget: 'Hedef',
            columnDetails: 'Detay',
            filterAllActions: 'Tüm aksiyonlar',
            action: {
                ban: 'Ban',
                unban: 'Ban kaldırma',
                forceLogout: 'Oturum kapatma',
                grantAdmin: 'Admin yapma',
                revokeAdmin: 'Adminlik alma',
                registrationSettingsChanged: 'Kayıt ayarı değişikliği',
                announcement: 'Duyuru',
                resetProfile: 'Profil temizleme'
            },
            empty: 'Henüz kayıtlı bir admin işlemi yok.',
            prev: 'Önceki',
            next: 'Sonraki'
        }
    },
    errors: {
        generic: 'Bir şeyler ters gitti.',
        notConnected: 'Bağlantı yok.',
        NOT_AUTHENTICATED: 'Oturumun bu işlem için doğrulanmadı. Tekrar giriş yapmayı dene.',
        ROOM_OFFLINE: 'Bu kişi şu an ortalıkta değil.',
        ROOM_LOCKED: 'Bu kapı kilitli.',
        ROOM_DND: 'Bu kişi şu an rahatsız edilmek istemiyor.',
        ROOM_FULL: 'Bu oda dolu.',
        NOT_MEMBER: 'Bu grubun üyesi değilsin.',
        BANNED: 'Bu odadan yasaklandın.',
        COOLDOWN: 'Bu odanın yakın zamanda kapısını çaldın - biraz sonra tekrar dene.',
        ALREADY_KNOCKING: 'Bu kapıyı zaten çalıyorsun.',
        RATE_LIMITED: 'Çok fazla kapı çaldın - biraz yavaşla.',
        KNOCK_EXPIRED: 'Bu kapı çalmanın süresi doldu.',
        KNOCK_ALREADY_RESOLVED: 'Bu kapı çalma zaten yanıtlandı.',
        KNOCK_REQUIRED: 'Bu odaya girmek için kapıyı çalman gerekiyor.',
        ALREADY_MEMBER: 'Bu kullanıcı zaten grubun bir üyesi.',
        GROUP_FULL: 'Bu grup üye limitine (20) ulaştı.',
        ALREADY_INVITED: 'Bu kullanıcının bu gruba zaten bekleyen bir daveti var.',
        INVITE_NOT_FOUND: 'Bu davet artık mevcut değil.',
        NOT_OWNER: 'Sadece grup sahibi üye çıkarabilir.',
        NOT_OWNER_DELETE: 'Grubu sadece sahibi silebilir.',
        GROUP_NOT_FOUND: 'Grup bulunamadı.',
        CANNOT_REMOVE_SELF: 'Kendini çıkarmak yerine gruptan ayrılmayı kullan.'
    }
};

export default tr;
